import { observer } from "mobx-react-lite";
import { Fragment, useState } from "react";
import {
  Col,
  Modal,
  Row,
  Table,
  Button,
  Input,
  Space,
  Steps,
  Segmented,
  Upload,
  message,
  Popconfirm,
  Tag
} from "antd";
import type { UploadProps } from 'antd';
import { CallManageStore } from "../../../store";
import { PlusOutlined } from "@ant-design/icons";
import "./index.css";

function AddPhone() {
  const { Column } = Table;
  const { TextArea } = Input;

  //tab切换手动录入/文件上传
  const segmentedChange = (value: string) => {
    CallManageStore.segValue = value
    setInputValue('')
    setFilteredData([])
    setDataSource([])
  };

  const [data, setDataSource] = useState<string[]>([]);;
  const [inputValue, setInputValue] = useState('');
  const handleInput = (e: { target: { value: string } }) => {
    setInputValue(e.target.value);
    setDataSource(e.target.value.split('\n'));
  };

  const handleKeyDown = (e: { keyCode: number; }) => {
    if (e.keyCode === 13) {
      const lines = inputValue.split('\n');
      if (lines.length > 1000) {
        message.error(`输入的数据不能大于1000条`);
        setInputValue(lines.slice(0, 1000).join('\n')); // 限制输入不超过1000条
      } else {
        // 截取最后一个 \n 之前的部分
        const result = inputValue.replace(/[\n]+$/, '');
        setInputValue(result);
      }
    }
  };
  const [filteredData, setFilteredData] = useState(CallManageStore.PhoneTabList);

  const toggleExceptions = () => {
    CallManageStore.showExceptions = !CallManageStore.showExceptions
    CallManageStore.resetPhoneData()  //重置分页
    CallManageStore.getPhonePageListByWhere(CallManageStore.showExceptions?false:true,false)
  }
const { Dragger } = Upload;
const [fileUploaded, setFileUploaded] = useState(false);
const [isUploading, setIsUploading] = useState(false); // 新增状态变量
const props: UploadProps = {
  beforeUpload(file, fileList) {
    setIsUploading(true); // 在开始上传时设置为 true
    return new Promise((resolve, reject) => {
      const isLt500Kb = file.size / 1024 <= 500; // 调整边界条件
      if (process.env.NODE_ENV !== 'production') {
        console.log(isLt500Kb, file.size / 1024); // 生产环境中移除或优化日志输出
      }
      if (!isLt500Kb) {
        message.error(file.name + '文件大小超出限制，请修改后重新上传');
        reject();
      } else {
        resolve();
      }
    });
  },
  name: 'file',
  action: '/api/ai/task/importPhone/'+CallManageStore.lookPower.temporaryId,
  accept: '.xlsx',
  onChange(info) {
    const { status, response } = info.file;
    CallManageStore.PhoneTab = response;
    if (status !== 'uploading') {
      if (response?.code == '500') {
        message.error(`文件上传失败: ${response?.msg}`);
        // 清除文件列表
        info.fileList = [];
        return;
      }
    }
    setFileUploaded(true);
    if (status == 'done') {
      message.success(`${info.file.name}`);
      setIsUploading(false); // 文件上传完成后设置为 false
    } else if (response?.code === 'error') {
      message.error(`${info.file.name} 文件上传失败.`);
    }
  },
  onDrop(e) { },
};
const columns = [
  {
    title: '手机号码',
    dataIndex: 'value',
    key: 'value',
  },
];
const steps = [
  {
    title: '上传号码',
  },
  {
    title: '号码确认',
  },
];
//下一步
const next = () => {
  if (CallManageStore.segValue == '文件上传') {
    if (!fileUploaded) {
      message.error('请录入数据!');
      return;
    }
    CallManageStore.getPhonePageListByWhere(true,false)
  } else {
    const lines = inputValue.split('\n');
    if (lines.length > 1000) {
      message.error(`输入的数据不能大于1000条`);
      setInputValue(lines.slice(0, 1000).join('\n')); // 限制输入不超过1000条
      setDataSource(lines.slice(0, 1000)); // 修复这里
      return;
    }
    if(data.length <= 0){
      message.error('请录入数据!');
      return;
    }
    setDataSource(lines); // 修复这里
    CallManageStore.addPhone(data)
  }
    CallManageStore.resetPhoneData()
    CallManageStore.showExceptions = false
    CallManageStore.current++;
    setInputValue('')
};
//上一步
const prev = () => {
  CallManageStore.current--;
  CallManageStore.segValue = '文件上传'
  setFileUploaded(false);
  CallManageStore.PhoneTabList = []
  setInputValue('')
};
//删除全部异常项
const onDelete = () => {
  let query ={
    temporaryId: CallManageStore.lookPower.temporaryId,
    state:1
  }
  CallManageStore.showDelete = true 
  CallManageStore.deletePhone(query)
  setSelectedRowKeys([])
};
const [selectedRowKeys, setSelectedRowKeys] = useState(Array<string>);
//删除选中项
const removeSelectedRows = () => {
  let query ={
    temporaryId: CallManageStore.lookPower.temporaryId,
    ids:selectedRowKeys
  }
  CallManageStore.deletePhone(query)
  setSelectedRowKeys([])
};
const onSelectChange = (keys: any, selectedRows: any) => {
  setSelectedRowKeys(keys);
};
const closeDetail = () => {
  CallManageStore.isOpenPhone = false
  CallManageStore.segValue = '文件上传'
  CallManageStore.PhoneTabList = []
  let query={
    temporaryId:CallManageStore.lookPower.temporaryId,
  }
  CallManageStore.getPhoneCount(query)
};
return (
  <Fragment>
    <Modal
      width={"640px"}
      centered
      title='添加号码'
      open={CallManageStore.isOpenPhone}
      destroyOnClose={true}
      onCancel={() => closeDetail()}
      footer={null}
      loading={CallManageStore.modalLoading}
    >
      <Steps
        style={{ marginBottom: "30px" }}
        current={CallManageStore.current}
        items={steps}
      />
      <div className="flex-down">
        {CallManageStore.current == 0 && (
          <Segmented<string>
            onChange={segmentedChange}
            options={['文件上传', '手动录入']} />
        )}
        {CallManageStore.current == 0 &&
          <a
            href={require("../../../assets/template/上传模板.xlsx")}
            download={"上传模板"}
          >
            <span>下载模板</span>
          </a>
        }
      </div>
      {CallManageStore.segValue == '文件上传' && CallManageStore.current == 0 && (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <PlusOutlined />
            </p>
            <p className="ant-upload-text">点击或拖拽文件到此处上传</p>
            <p className="ant-upload-hint">
              仅支持xlsx文件,且不超过500kb
            </p>
          </Dragger>
        </div>
      )}
      {CallManageStore.segValue == '手动录入' && CallManageStore.current == 0 && (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <Row gutter={24} style={{ marginTop: "12px" }}>
            <Col span={11} offset={1}>
              <div className="phone-name">参考格式: 电话号码</div>
              <div className="phone-hint">
                - 请严格按照参考格式顺序录入。<br />
                - 号码和变量间用英文逗号分割，不同号码间用回车分割。 <br />
                - 最多可输入1000条数据。
              </div>
              <TextArea rows={6} onChange={handleInput}
                onKeyDown={handleKeyDown} value={inputValue} />
              <div className="phone-astrict" style={{ textAlign: 'right' }}>{`已输入${data.length}/1000条数据`}</div>
            </Col>
            <Col span={11} offset={1}>
              <div className="phone-name">预览</div>
              <Table
                columns={columns}
                dataSource={data.map((item, index) => ({ key: index, value: item })).slice(0, 3)}
                pagination={false}
                style={{ marginTop: 10 }}
              />
              <div className="phone-astrict">仅展示前3条用于检查格式,全量数据可点击下一步查看</div>
            </Col>
          </Row>
        </div>
      )}
      {CallManageStore.current == 1 && (
        <div>
          <Row>
            <Col span={8}>
              <Button onClick={() => toggleExceptions()}>
                {CallManageStore.showExceptions ? '显示异常项' : '显示全部'}
              </Button>
            </Col>
            <Col span={10} offset={6}>
              <Popconfirm
                title=''
                description="是否确定删除?"
                onConfirm={() => onDelete()}
                okText="确定"
                cancelText="取消"
              >
                <Button disabled={CallManageStore.showDelete}>删除全部异常项</Button>
              </Popconfirm>
              <Popconfirm
                title=''
                description="是否确定删除?"
                onConfirm={() => removeSelectedRows()}
                okText="确定"
                cancelText="取消"
              >
                <Button style={{ marginLeft: '10px' }} disabled={selectedRowKeys.length == 0}>删除选中项</Button>
              </Popconfirm>
            </Col>
          </Row>
          <Table
            dataSource={CallManageStore.allPhone.records}
            scroll={{ x: 500, y: 'calc(100vh - 430px)' }}
            style={{ marginTop: '20px', marginBottom: '20px' }}
            rowSelection={{ type: 'checkbox', selectedRowKeys, onChange: onSelectChange, }}
            pagination={{
              current: CallManageStore.phoneData.page,
              pageSize: CallManageStore.phoneData.size,
              onChange: CallManageStore.phoneData.changePage,
              pageSizeOptions: [10, 20, 50, 100],
              showSizeChanger: true,
              total: CallManageStore.allPhone.total,
              showTotal: () =>
                `共计${CallManageStore.allPhone.total}条`,
              position: ["bottomLeft"],
            }}
            rowKey='id'
          >
            <Column
              ellipsis={true}
              width={80}
              title="手机号码"
              dataIndex="phone"
            />
            <Column
              ellipsis={true}
              width={80}
              title="状态"
              dataIndex="state"
              render={(state) => {
                if (state == "0") {
                  return <Tag color="green">正常</Tag>;
                } else if (state == "1") {
                  return <Tag color="red">异常</Tag>;
                }
              }}
            />
          </Table>
        </div>
      )}
      <div
        style={{ textAlign: "right" }}
      >
        <Space>
          <Button
            htmlType="reset"
            onClick={() => closeDetail()}
          >
            取消
          </Button>
          {CallManageStore.current > 0 && (
            <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
              上一步
            </Button>
          )}
          {CallManageStore.current < steps.length - 1 && (
            <Button disabled={isUploading} type="primary" onClick={() => next()}>
              下一步
            </Button>
          )}
          {CallManageStore.current == steps.length - 1 && (
            <Button type="primary" onClick={() => CallManageStore.submitPhone()}>
              确定
            </Button>
          )}
        </Space>
      </div>
    </Modal>
  </Fragment>
);
}

export default observer(AddPhone);
